import { useMemo } from 'react';

const LABELS = ['Too weak', 'Weak', 'Fair', 'Strong', 'Excellent'];
const COLORS = ['bg-rose-600', 'bg-orange-500', 'bg-amber-400', 'bg-emerald-500', 'bg-emerald-400'];

export function scorePassword(password) {
  if (!password) return { score: 0, tips: [] };
  let score = 0;
  const tips = [];

  if (password.length >= 8) score += 1; else tips.push('use at least 8 characters');
  if (password.length >= 12) score += 1; else if (password.length >= 8) tips.push('12+ characters is much safer');
  if (/[a-z]/.test(password) && /[A-Z]/.test(password)) score += 1; else tips.push('mix upper and lower case');
  if (/\d/.test(password)) score += 1; else tips.push('add a number');
  if (/[^A-Za-z0-9]/.test(password)) score += 1; else tips.push('add a symbol like ! or #');

  if (/^[a-zA-Z]+$/.test(password) || /^\d+$/.test(password)) score -= 1;
  if (/(.)\1{2,}/.test(password)) { score -= 1; tips.push('avoid repeated characters'); }
  if (/^(password|qwerty|admin|welcome|letmein|iloveyou|truthconfession)/i.test(password)) {
    score = 0;
    tips.push('this looks like a common password');
  }

  return { score: Math.max(0, Math.min(4, score)), tips: tips.slice(0, 2) };
}

export function PasswordStrengthMeter({ password }) {
  const { score, tips } = useMemo(() => scorePassword(password), [password]);

  if (!password) return null;

  return (
    <div className="mt-2" data-testid="password-strength-meter">
      <div className="flex gap-1">
        {[0, 1, 2, 3].map((i) => (
          <div
            key={i}
            className={`h-1.5 flex-1 rounded-full transition-colors duration-300 ${i <= score - 1 ? COLORS[score] : 'bg-white/10'}`}
          />
        ))}
      </div>
      <div className="flex items-baseline justify-between mt-1 gap-3">
        <span className="text-[11px] font-medium" data-testid="password-strength-label">{LABELS[score]}</span>
        {tips.length > 0 && (
          <span className="text-[11px] text-muted-foreground text-right" data-testid="password-strength-tips">
            Try to {tips.join(' and ')}
          </span>
        )}
      </div>
    </div>
  );
}
